/**
 * Utility condivise per il modulo Agenda.
 */

/**
 * Formatta orario rimuovendo i secondi: "09:00:00" → "09:00"
 */
export function formatTime(time: string | null | undefined): string {
  if (!time) return ''
  const parts = time.split(':')
  return `${parts[0]}:${parts[1]}`
}

/**
 * Parse working hours format "HH:MM-HH:MM|day,day,day"
 * Returns start and end as hour numbers (0-23).
 *
 * Copiata da CalendarWeekView / CalendarDayView — logica invariata.
 */
export const parseWorkingHoursRange = (value: string | undefined): { startHour: number; endHour: number } => {
  const DEFAULT_START = 9
  const DEFAULT_END = 18

  if (!value || !value.includes("|")) {
    return { startHour: DEFAULT_START, endHour: DEFAULT_END }
  }

  try {
    const [timePart] = value.split("|")
    const [startTime, endTime] = timePart.split("-")
    const startHour = parseInt(startTime.split(":")[0], 10)
    const endHour = parseInt(endTime.split(":")[0], 10)

    if (isNaN(startHour) || isNaN(endHour)) {
      return { startHour: DEFAULT_START, endHour: DEFAULT_END }
    }

    return { startHour, endHour }
  } catch {
    return { startHour: DEFAULT_START, endHour: DEFAULT_END }
  }
}
